import { render } from "./TaxpayerDatabase.vue?vue&type=template&id=7b0a9d60&scoped=true"
import script from "./TaxpayerDatabase.vue?vue&type=script&lang=js"
export * from "./TaxpayerDatabase.vue?vue&type=script&lang=js"

import "./TaxpayerDatabase.vue?vue&type=style&index=0&id=7b0a9d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b0a9d60"]])

export default __exports__